/*
 * Validates a login identifier that may be an email OR a phone number.
 * Hungarian phone formats accepted: +36…, 0036…, 06…, national 70…
 */

import i18n from "../../i18n";

const EMAIL_RE = /\S+@\S+\.\S+/;

export function isEmailIdentifier(value = "") {
    return String(value).includes("@");
}

export function identifierValidator(value = "") {
    const raw = String(value || "").trim();

    if (!raw) return i18n.t('validation_email_or_phone_required');

    if (isEmailIdentifier(raw)) {
        if (!EMAIL_RE.test(raw)) return i18n.t('validation_enter_valid_email');

        return "";
    }

    const digits = raw.replace(/\D+/g, "");

    if (digits.length < 9) return i18n.t('validation_enter_valid_phone');

    return "";
}

export function normalizePhone(raw = "", defaultCountry = "36") {
    let digits = String(raw).replace(/\D+/g, "");

    if (!digits) return "";
    if (digits.startsWith("00")) digits = digits.slice(2);
    else if (digits.startsWith("06")) digits = `${defaultCountry}${digits.slice(2)}`;
    else if (digits.length === 9) digits = `${defaultCountry}${digits}`;

    return digits;
}

